import { render, staticRenderFns } from "./node.vue?vue&type=template&id=b4efbcf0"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports